import { useRef, useState } from 'react';
import loadable from '@loadable/component';

import { ClickType } from '@jsmdg/tracking';
import { trackImageSlide } from '../ImageGallery/imageGallery.tracking';
import { MediaSlider } from './MediaSlider';

const MediaModal = loadable(async () => import('./MediaModal'));

export const MediaCarouselContainer = ({
    onVideoFullscreenChange,
}: {
    readonly onVideoFullscreenChange?: (isFullscreen: boolean) => void;
}): JSX.Element => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const activeSlideIndexRef = useRef(0);

    const handleIndexChange = (i: number, url: string): void => {
        if (i !== activeSlideIndexRef.current) {
            trackImageSlide(
                activeSlideIndexRef.current < i ? ClickType.SlideNext : ClickType.SlidePrevious,
                url,
            );
        }

        activeSlideIndexRef.current = i;
    };

    return (
        <>
            <MediaModal
                isOpen={isModalOpen}
                onRequestClose={setIsModalOpen}
                onVideoFullscreenChange={onVideoFullscreenChange}
            />
            <MediaSlider
                withAddOns
                withImagePreview
                setIsModalOpen={setIsModalOpen}
                handleIndexChange={handleIndexChange}
                handleVideoFullscreenChange={onVideoFullscreenChange}
            />
        </>
    );
};
